import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Check } from 'lucide-react';
import { MEDICINE_CABINET } from '../mock/products';
import { useApp } from '../context/AppContext';
import { useCurrency } from '../context/CurrencyContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EssentialsKit = () => {
  const { fmt } = useCurrency();
  const { addToCart } = useApp();
  const [k, setK] = useState(MEDICINE_CABINET);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/kits/medicine-cabinet`);
        if (!cancelled && data) setK(data);
      } catch { /* fall back to mock */ }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleAdd = () => addToCart({
    id: `kit-${k.id}`,
    name: k.title,
    strength: 'Essentials Kit',
    packaging: `${(k.items || []).length} items`,
    price: k.price,
    image: k.image,
    catLabel: k.tag,
  });

  return (
    <section className="max-w-7xl mx-auto px-6 pt-16">
      <span className="inline-block bg-brand-soft text-brand text-[11px] tracking-[0.18em] px-3 py-1 rounded-full uppercase mb-3 font-semibold">THE ESSENTIALS</span>
      <h2 className="font-serif text-[34px] md:text-[42px] leading-tight text-neutral-900 dark:text-neutral-100 mb-2 tracking-tight">Stock the cabinet before you need it</h2>
      <p className="text-neutral-500 dark:text-neutral-400 text-[15px] mb-6">{k.subtitle}</p>

      <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-0 rounded-2xl border border-neutral-200 dark:border-neutral-800 overflow-hidden bg-white dark:bg-[#141416] shadow-sm">
        <div className="bg-neutral-100 dark:bg-neutral-900">
          {k.image && <img src={k.image} alt={k.title} className="w-full h-full object-cover min-h-[220px]" onError={(e) => { e.currentTarget.style.display = 'none'; }} />}
        </div>
        <div className="p-6 md:p-8">
          <span className="inline-block bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 text-[10.5px] tracking-[0.15em] px-2.5 py-1 rounded uppercase mb-3">{k.tag}</span>
          <h3 className="font-serif text-[28px] text-neutral-900 dark:text-neutral-100 mb-2 tracking-tight">{k.title}</h3>
          <p className="text-neutral-500 dark:text-neutral-400 text-[14px] mb-5">{k.subtitle}</p>

          <ul className="space-y-3 mb-6">
            {(k.items || []).map((it, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <Check size={16} className="text-brand mt-1 shrink-0" />
                <div>
                  <div className="text-[14px] text-neutral-800 dark:text-neutral-100"><span className="font-medium">{it.name}</span> <span className="text-neutral-500 text-[13px] ml-1">{it.pack}</span></div>
                  <div className="text-[12.5px] text-neutral-500 dark:text-neutral-400">{it.desc}</div>
                </div>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-3 flex-wrap">
            <span className="text-neutral-900 dark:text-neutral-100 text-[22px] font-medium">{fmt(k.price)}</span>
            <button onClick={handleAdd} className="btn-brand ml-auto text-[13.5px] font-semibold rounded-full px-5 py-2.5">Add Kit — {fmt(k.price)}</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EssentialsKit;
